<template>
  <div class="content2">
    <div class="img_bj">
      <img src="../../assets/images/index/底图.png" />
      <div class="con">
        <div class="head_title">
          <div class="title1">关于我们</div>
          <div class="title2">了解金牌·桔家云整装，让更多的人享受到优质的整装服务及产品</div>
          <div class="Scribing"></div>
        </div>
        <div class="main">
          <div class="block">
            <el-carousel height="680px">
              <el-carousel-item v-for="(item,index) in list" :key="index">
                <div class="carousel_main">
                  <div class="carousel_main">
                    <img :src="item.imgurl" />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      list: [
        {
          imgurl: require("../../assets/images/index/品牌核心.png"),
          name: "1"
        },
        {
          imgurl: require("../../assets/images/index/品牌核心.png"),
          name: "2"
        },
        {
          imgurl: require("../../assets/images/index/品牌美学.png"),
          name: "3"
        },
        {
          imgurl: require("../../assets/images/index/品牌魅力.png"),
          name: "4"
        },
        {
          imgurl: require("../../assets/images/index/品牌实力.png"),
          name: "5"
        },
        {
          imgurl: require("../../assets/images/index/品牌特权.png"),
          name: "6"
        },
        { imgurl: require("../../assets/images/index/品牌优势.png"), name: "7" }
      ]
    };
  },
  methods: {}
};
</script>
<style scoped>
.content2 {
  width: 100%;
  overflow: hidden;
}
.img_bj {
  width: 100%;
  position: relative;
}
.img_bj img{
  height: 917px;
}
.con {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.head_title {
}
.title1 {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  color: #333333;
}
.title2 {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #666666;
}
.Scribing {
  width: 50px;
  height: 6px;
  background-color: #bc001d;
  margin: 0 auto;
  margin-top: 20px;
}
.main {
  width: 1280px;
  margin: 0 auto;
  margin-top: 50px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.carousel_main {
  width: 1280px;
}
.carousel_main img {
  width: 100%;
  height: 100%;
}
>>>.el-carousel__indicators--horizontal{
  bottom: 20px;
}
.Seemore {
  width: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #bc001d;
  border: solid 1px #bc001d;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 60px;
}
</style>
